<template>
  <div class="security-info-section">
    <b-card class="shadow" no-body>
      <b-card-body>
        <b-card-title class="dark-variant">
          Security
        </b-card-title>
        <div class="security-info">
          <b-card-text>
            <div class="primary-email">
              <label for="first-question" class="dark-variant">Primary Email</label>
              <span>{{ primaryEmail }}</span>
            </div>
            <!-- <div class="secondary-email">
              <label for="first-question" class="dark-variant">Secondary Email</label>
              <span>{{ secondaryEmail }}</span>
            </div> -->
            <div class="phone-number">
              <label for="first-question" class="dark-variant">Phone Number</label>
              <span>{{ displayPhone || 'Not added' }}</span>
              <span class="icon ok_icon" v-if="displayPhone">
                <i class="material-icons">check_circle</i>
              </span>
              <button v-b-modal.security class="edit-security-info">
                <b-icon icon="brush"></b-icon>
                <span class="edit" id="security-edit">Edit</span>
              </button>
            </div>
            <b-alert
              v-if="phoneNumberChanged"
              show
              dismissible
              variant="success"
            >Phone Number Verified Successfully.</b-alert>
          </b-card-text>
          <b-modal id="security" size="md" title="Change Phone Number" v-bind:hide-footer="true">
            <b-form v-if="needVerifyPhone" @submit.stop.prevent="submitSecurityForm">
              <span v-if="errors.phoneError" style="color: red;">{{ errors.phoneError }}<br/></span>
              <label for="first-question" class="dark-variant">Country Code + Phone Number</label>
              <b-form-input
                v-model="number"
                type="text"
                placeholder="Enter your full phone number"
                :class="errors.number ? 'errors' : ''"
              ></b-form-input>
              <span class="text-danger float-right" v-if="errors.number">{{ errors.number}}</span>
              <br/>
              <hr />
              <div class="text-right">
                <b-button variant="secondary" @click="$bvModal.hide('security')" class="mr-1">Cancel</b-button>
                <b-button variant="primary" type="submmit" class="ml-1">OK</b-button>
              </div>
            </b-form>
            <b-form v-if="!needVerifyPhone" @submit.stop.prevent="submitVerifyPhone">
              <span v-if="errors.otpError" style="color: red;">{{ errors.otpError }}<br/></span>
              <span style="color: green;">An OTP code has been sent to your phone, please check and veirfy your new phone number.</span><br/><br/>
              <label class="dark-variant">OTP Code</label>
              <b-form-input
                v-model="optcode"
                type="number"
                placeholder="Enter OTP Code"
                :class="errors.optcode ? 'errors' : ''"
                maxlength="6"
              ></b-form-input>
              <span class="text-danger float-right" v-if="errors.optcode">{{ errors.optcode}}</span>
              <br/>
              <hr />
              <div class="text-right">
                <b-button variant="secondary" @click="$bvModal.hide('security')" class="mr-1">Cancel</b-button>
                <b-button variant="primary" type="submmit" class="ml-1">OK</b-button>
              </div>
            </b-form>

          </b-modal>
        </div>
      </b-card-body>
    </b-card>
    <!--
      Security Question section is hidden for now (requested).
      The markup is kept in git history; the sQuestions / sQuestionAnswers actions and
      state are untouched, so restoring it is a matter of putting this card back.
    -->

    <!-- <toggle-password></toggle-password> -->
    <!-- <router-link class"">Change Password</router-link> -->
    <b-card class="shadow change-password-card">
      <router-link :to="{ name: 'changepassword' }" class="change-password-link">
        <b-card-title class="dark-variant">
          <span>Change Password</span>
          <span class="cp-arrow" aria-hidden="true">
            <i class="material-icons">chevron_right</i>
          </span>
        </b-card-title>
      </router-link>
    </b-card>

    <div class="update-button">
      <b-button class="update-security">Update Security</b-button>
    </div>
    <input type="hidden" v-model="statechangevalue"/>
  </div>
</template>
<script>
import ChangePassword from "./ChangePassword";
import TogglePassword from "./TogglePassword.vue";
import questionList from "../../json/question.json";
import { mapActions, mapState } from "vuex";
import { resolvePhone } from "../../utils/format";
export default {
  name: "SecurityInfo",
  components: {
    TogglePassword: TogglePassword,
    ChangePassword,
  },
  computed: {
    /**
     * The phone shown on this page comes from GET /v1/profile:
     *   author.authorphone[0] -> { phone: "9876540003", country_code: "+977" }
     *
     * resolvePhone (utils/format.js) covers every shape this payload has arrived in -
     * see the comment there. When it returns "" the account genuinely has no number on
     * file, and in development we log what was actually received so that is provable
     * rather than a guess.
     */
    displayPhone: function () {
      const value = resolvePhone(this.profile);
      if (!value && process.env.NODE_ENV !== 'production') {
        const author = (this.profile && (this.profile.author || this.profile[0] && this.profile[0].author)) || null;
        if (author) {
          console.warn('[security] No phone found on the profile. author.authorphone =',
            JSON.stringify(author.authorphone));
        }
      }
      return value;
    },

    ...mapState(["sQuestions", "sQuestionAnswers", "profile", "countries", "successmessage", "errormessage", "message",]),
  },
  created() {
    this.listProfile();
    this.listCountries();
    this.listSQuestions();
    this.listSQuestionAnswers();
  },
  data() {
    return {
      securityQuestions: questionList,
      primaryEmail: "",
      currentLocation: JSON.parse(localStorage.getItem("currentLocation")),
      secondaryEmail: "",
      country: null,
      number: "",
      optcode: "",
      question: null,
      answer: "",
      type: [
        "text",
        "number",
        "email",
        "password",
        "search",
        "url",
        "tel",
        "date",
        "time",
        "range",
        "color",
      ],
      needVerifyPhone: true,
      emailReg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      phoneReg: /^([(+]*[0-9]+[()+. -]*)$/,
      securityQuestionUploaded: false,
      phoneNumberChanged: false,
      statechangevalue: "",
      errors: [],
    };
  },
  methods: {
    ...mapActions(["listSQuestions", "listSQuestionAnswers", "listProfile", "listCountries"]),
    submitSecurityForm(e) {
      e.preventDefault();
      this.phoneNumberChanged = false
      this.errors = [];
      console.log("Security");
      if (this.number == "") {
        this.errors["number"] = "Phone number required";
      } else if (!this.phoneReg.test(this.number)) {
        this.errors["number"] = "Phone format invalid.";
      } else if (this.number.length < 6) {
        this.errors["number"] = "Phone have minimum 6 digits.";
      } else if (this.number == this.profile.author.phone) {
        this.errors["number"] = "Can't change same phone number.";
      } else {
        let formData = new FormData();
        formData.append("phone", this.number);
        formData.append("device_id", "AmejWeb2020");

        for (var pair of formData.entries()) {
          console.log(pair[0]+ ', ' + pair[1]); 
        }

        this.$store.dispatch("changePhoneNumber", formData).then(() => {
          console.log("smsg", this.successmessage)
          console.log("emsg", this.errormessage)
          if (this.successmessage == "success") {
            console.log("111111")
            this.needVerifyPhone = false
            this.phoneNumberChanged = false;
          } else if (this.errormessage == "errormessage") {
            console.log("2222222")
            this.statechangevalue = "what  is this"
            this.errors['phoneError'] = "Sorry! Invalid Phone Number";
          }
        });
      }
    },
    submitVerifyPhone(e){
      e.preventDefault();
      this.errors = [];
      if(this.optcode == ""){
        this.errors['optcode'] = "OTP Code required.";
      }else if(this.optcode.length != 6){
        this.errors['optcode'] = "Incorrect OTP Code length.";
      }else{
        let formData = new FormData();
        formData.append("otp", this.optcode);

        this.$store.dispatch("confirmChangePhone", formData).then(() => {
          if (this.successmessage == "success") {
            this.phoneNumberChanged = true;
            this.needVerifyPhone = true
            this.$bvModal.hide("security");
          } else if (this.errormessage == "errormessage") {
            this.statechangevalue = "sorry for that"
            this.errors['otpError'] = "Sorry! Invalid OTP Code";
          }
        });
      }
    },
    submitSecurityQuestion(e) {
      e.preventDefault();
      this.errors = [];
      console.log("Security Question");
      if (!this.question) {
        this.errors["question"] = "Question required";
      } else if (this.answer == "") {
        this.errors["answer"] = "Answer required";
      } else {
        this.$bvModal.hide("security-question");
        let formData = new FormData();
        formData.append("question", this.question);
        formData.append("answer", this.answer);

        this.$store.dispatch("createQuestonAnswer", formData).then(() => {
          if (this.successmessage == "success") {
            this.securityQuestionUploaded = true;
            setTimeout(function () {
              location.reload();
            }, 2000);
          } else if (this.errormessage == "errormessage") {
            this.dismissCountDown = true;
            //location.reload();
            // this.$router.replace({name:"phonenumber"});
          }
        });
      }
    },
  },
  mounted() {
    this.primaryEmail = this.profile.author.email
    this.number = this.profile.author.phone
  },
};
</script>
<style lang="scss">
  @import '../../css/style.scss';
</style>
<style type="text/css" scoped>
.ok_icon>i{
    font-size: 16px;
    color: #28a745;
  }

/* Change Password row.
   The arrow used to be a faint inline glyph that read as a stray character. It is now a
   filled circular chevron pinned to the right, so the row is obviously a link. */
.change-password-card .change-password-link{
  display: block;
  text-decoration: none;
  color: inherit;
  font-size: inherit;
}
.change-password-card .card-title{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0;
}
.change-password-card .cp-arrow{
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #eef4fb;
  color: #0066b3;
  flex: 0 0 auto;
  transition: background 0.15s ease, transform 0.15s ease;
}
.change-password-card .cp-arrow > i{
  font-size: 20px;
  line-height: 1;
}
.change-password-card .change-password-link:hover .cp-arrow{
  background: #0066b3;
  color: #fff;
  transform: translateX(2px);
}
</style>